import { PopconfirmProps } from 'antd';

export enum Languages {
    RU = 'ru',
    EN = 'en',
    KK = 'kk',
    QQ = 'qq',
}

export type Banner = {
    id: string;
    title_ru: string;
    title_en: string;
    title_kk: string;
    title_qq: string;
    url_ru: string;
    url_en: string;
    url_kk: string;
    url_qq: string;
    imageId: string;
    displayed: boolean;
    order?: number;
};

export type UpdateBannerDTO = Omit<Banner, 'displayed' | 'order'>;

export type CreateBannerDTO = Omit<UpdateBannerDTO, 'id'>;

export enum ModalFormMode {
    CREATE = 'create',
    UPDATE = 'update',
    CLOSE = 'close',
}

export interface TableRowProps extends React.HTMLAttributes<HTMLTableRowElement> {
    'data-row-key': string;
}

export enum ChangeTypes {
    CREATE,
    DELETE,
    UPDATE,
}

export interface Change {
    type: ChangeTypes;
    banner: Banner;
}

export interface AdminBannersProps {
    language: Languages;
    serviceUrl: string;
    banners: Banner[];
    config: { enableCrop: boolean };
}

export interface BannerFormProps {
    mode: ModalFormMode;
    initialValues?: Banner;
    onSubmit: (values: any) => void;
    close: () => void;
    enableCrop?: boolean;
}

export interface ImageUploadComponentProps {
    selectImage: (image: any) => void;
    getInitialImageId: () => string | null;
    enableCrop?: boolean;
}

export type ConfirmButtonProps = PopconfirmProps & {
    children: React.ReactNode;
};

export interface UploadFormItemProps {
    label: string;
    name: string;
}
